// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__33Wbu","row":"ProcedureTreatmentSummary_row__GMWh0"};